import { Pipe, type PipeTransform } from '@angular/core';
import { type ActivatedRoute } from '@angular/router';
import { parentActivatedRouteAtAnchor } from '../router.utils';

@Pipe({
  name: 'relativeToAnchor',
})
export class RouteRelativeToAnchorPipe implements PipeTransform {
  transform(activatedRoute: ActivatedRoute, anchor: string): ActivatedRoute {
    return parentActivatedRouteAtAnchor(activatedRoute, anchor);
  }
}
